module.exports = __webpack_public_path__ + "static/media/desktop-holes.svg";